import { faIcon } from "@utils/faIcon"

import { EmptyState } from "@molecules"

import styles from "@organisms/ObjectsView/CardsView/CardsViewEdgeStates/CardsViewEdgeStates.module.scss"
import CardsViewSkeletonCard from "@organisms/ObjectsView/CardsView/CardsViewEdgeStates/CardsViewSkeletonCard/CardsViewSkeletonCard"
import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"

import { CLEAR_SEARCH_EVENT } from "@constants/events"

export default function CardsViewNoResultsState() {
    const { tabContentName } = useObjectsView()

    // e.g. "All Open Jobs" -> "open jobs".
    const listName = tabContentName.toLowerCase().replace("all", "").replace("&", "or").trim()

    return (
        <div className={styles.base}>
            <div className={styles.graphic}>
                <div className={styles.graphicCard}>
                    <CardsViewSkeletonCard />
                </div>
            </div>
            <EmptyState
                variant="default"
                icon={faIcon({ name: "ban", style: "solid" })}
                title="No results found..."
                supportText={`There are no ${listName} matching the search`}
                primaryCTA={{
                    children: "Clear search",
                    leftIcon: faIcon({ name: "xmark", style: "regular" }),
                    onClick: () => window.dispatchEvent(new CustomEvent(CLEAR_SEARCH_EVENT, {})),
                    noDebounce: true,
                }}
            />
        </div>
    )
}
